import { useEffect, useRef, useState } from "react";
import { ENV } from "../../environmentVariables";
import { useNavigate } from "react-router-dom";

const defaultProps = {
  description: "reason for production ignore",
  isRoute: false, //
  disableToggle: false,
  toggleKey: "=", //default toggle key
  children: null, //content to render
  altContent: <></>
};

function ProdIgnore(props = defaultProps) {
  const varName = "prodIgnore";

  const [override, setOverride] = useState(sessionStorage.getItem(varName) === "true");
  //ref to ensure multiple listeners are not attached
  const listenerAttached = useRef(false);

  const router = useNavigate();

  useEffect(() => {
    if (override === true) document.title = `[prod_ignore_preview]`;
    else document.title = "FileFreak.io";
  }, [override]);

  if ((ENV === "dev" || ENV === "staging") && props.disableToggle !== true && listenerAttached.current === false) {
    if (!sessionStorage.getItem(varName)) sessionStorage.setItem(varName, override.toString());
    let target_key = props.toggleKey ?? "=";
    window.addEventListener("keydown", (event) => {
      if (event.key === target_key) {
        setOverride((prev) => {
          let v = !prev;
          sessionStorage.setItem(varName, v.toString());
          return v;
        });
      }
    });
    //listener now attached
    listenerAttached.current = true;
  }

  if (!props.description || props.description.length < 5) throw new Error("A verbose description is required for all production ignore tags");

  if (override === false && ENV !== "prod" && ENV !== "production") {
    return props.children;
  }

  if (props.isRoute === true && override === true) {
    router("/not-found");
  }

  return props.altContent ?? null;
}

export default ProdIgnore;
